import React from "react";
import Section from "./../Section";
import SectionHeader from "./../SectionHeader";
import "./styles.scss";

function QuizQuestion(props) {
  return (
    <Section color={props.color} size={props.size}>
      <div className="QuizQuestion__container container">
        <div className="is-centered is-desktop">
          <div className="column is-10 is-offset-1 has-text-centered-touch">
            <figure className="QuizQuestion__image image">
              <img src={props.image} alt="question illustration" />
            </figure>
            <SectionHeader title={props.title} size={4} centered />
          </div>
        </div>
      </div>
    </Section>
  );
}

export default QuizQuestion;
